<template>
  <div class="middle-top">
    <div class="c-title">
      职工体质单项达标率
      <div class="right">
        <div class="item color-1">合格人数</div>
        <div class="item color-2">不合格人数</div>
        <div class="item none">% 为合格率</div>
      </div>
    </div>
    <div class="container">
      <div id="chart" style="transform-origin: 0px 0px; height: 355px; width: 768px" :style="`transform: scale(${scale})`"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    sourceData: {
      default() {
        return []
      },
    },
  },
  watch: {
    sourceData: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById('chart'))

    this.init()

    this.scale = window.innerWidth / 1920
  },
  methods: {
    init() {
      const xData = []
      const qualified = []
      const unqualified = []
      const markList = []

      this.sourceData.forEach((row, i) => {
        xData.push(row.label)
        qualified.push(row.合格人数 * 1)
        unqualified.push(row.参与人数 * 1 - row.合格人数 * 1)

        markList.push({
          name: row.label,
          value: Math.floor(row.rank * 100) + '%',
          xAxis: i,
          yAxis: row.参与人数 * 1 + 1,
        })
      })

      const label = {
        show: true,
      }

      this.myChart.setOption({
        xAxis: {
          data: xData,
          axisLabel: {
            show: true,
            interval: 0,
            color: '#fff',
          },
        },
        yAxis: {
          // max: function (value) {
          //   return Math.floor((value.max + 10) / 10) * 10
          // },
          axisLabel: {
            show: true,
            interval: 0,
            color: '#fff',
          },
        },
        series: [
          {
            name: '合格',
            type: 'bar',
            stack: 'total',
            label: label,
            data: qualified,
            itemStyle: {
              color: '#2084FF',
            },
            markPoint: {
              symbol: 'pin',
              data: markList,
            },
          },
          {
            name: '不合格',
            type: 'bar',
            stack: 'total',
            itemStyle: {
              color: '#F7B500',
            },
            label: label,
            data: unqualified,
          },
        ],
      })
    },
  },
  data() {
    return {
      scale: 1,
    }
  },
}
</script>

<style lang="less" scoped>
.middle-top {
  padding: 0 30px;
  .c-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    padding: 12px 0px;
    background: url(../../assets/gonghui/middle-top-line.png) no-repeat bottom center / contain;
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .item {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 14px;
        & + .item {
          margin-left: 16px;
        }
        &::before {
          content: ' ';
          display: block;
          width: 18px;
          height: 18px;
          margin-right: 8px;
          border-radius: 2px;
          background: #2084ff;
        }
        &.color-2 {
          &::before {
            background: #f7b500;
          }
        }
        &.none {
          &::before {
            display: none;
          }
        }
      }
    }
  }
  .container {
    padding: 0 -30px;
  }
}
</style>
